// project import
import navigation from './navigation';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [navigation]
};

export default menuItems;
